export const autocompleteMap: Record<string, string> = {
  vorname: "given-name",
  nachname: "family-name",
  houseNumber: "address-line2",
  ort: "address-level2",
  plz: "postal-code",
  telefonnummer: "tel",
  email: "email",
  "geburtsdatum.tag": "bday-day",
  "geburtsdatum.monat": "bday-month",
  "geburtsdatum.jahr": "bday-year",
};
